import React from 'react'
import MaskedInput from 'react-text-mask'
export const CodigoTabelaField = ({ inputRef, ...rest }) => {
  return (
    <MaskedInput
      {...rest}
      style={{ textTransform: 'uppercase' }}
      mask={[
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '_',
        'S',
        /[0-9]/,
        /[0-9]/,
        'C',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[aAfFiIqQtT]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[a-z-A-Z-0-9]{0,1}/
      ]}
      placeholderChar={'\u2000'}
    />
  )
}

export default CodigoTabelaField



// WEBPACK FOOTER //
// ./src/components/Fields/CodigoTabelaField.js